import classNames from "classnames/bind";
import React from "react";
import styles from "./InsightsDashboardThumbnailPlaceholder.module.scss";

const cx = classNames.bind(styles);

/**
 * "Nodes" are the circles (dots) appearing on top of each bar:
 */
const NODES = [
  [69, 80],
  [113, 56],
  [157, 90],
  [201, 44],
  [245, 68],
] as const;

/**
 * A decorative placeholder graphic shown in the insights dashboard image cards
 * when a dashboard has no thumbnail. Renders a muted analytics illustration (a
 * small bar chart with a trend line) that fills its container and inherits the
 * design system's colour tokens.
 */
export const InsightsDashboardThumbnailPlaceholder = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 320 160"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="No thumbnail available"
  >
    {/* baseline the bars sit on */}
    <line
      className={cx("baseline")}
      x1="44"
      y1="124"
      x2="276"
      y2="124"
      strokeWidth="2"
      strokeLinecap="round"
    />

    {/* bars of varying heights to suggest a chart */}
    <rect
      className={cx("bar")}
      x="56"
      y="80"
      width="26"
      height="44"
      rx="4"
    />
    <rect
      className={cx("bar")}
      x="100"
      y="56"
      width="26"
      height="68"
      rx="4"
    />
    <rect
      className={cx("bar")}
      x="144"
      y="90"
      width="26"
      height="34"
      rx="4"
    />
    <rect
      className={cx("bar")}
      x="188"
      y="44"
      width="26"
      height="80"
      rx="4"
    />
    <rect
      className={cx("bar")}
      x="232"
      y="68"
      width="26"
      height="56"
      rx="4"
    />

    {/* trend line across the bar tops with node markers */}
    <polyline
      className={cx("line")}
      points="69,80 113,56 157,90 201,44 245,68"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {NODES.map(([nodeX, nodeY]) => (
      <circle
        key={`${nodeX}-${nodeY}`}
        className={cx("node")}
        cx={nodeX}
        cy={nodeY}
        r="4"
        strokeWidth="2"
      />
    ))}
  </svg>
);
